import React, { useState, useEffect } from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import TraitsKey from "../traitsKey/traitsKey";
import RingsViewHeader from "../ringsViewHeader/ringsViewHeader";
import { useTranslation } from "react-i18next";
import ShareIcons from "../shareIcons/shareIcons";
import Cta from "../cta/Cta";
import "./ringsView.scss";
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";

export default function RingsView(props) {
  const { t } = useTranslation("common");

  const [activeSlide, setActiveSlide] = useState(0);
  const [stage, setStage] = useState("");
  const [swiper, setSwiper] = useState(null);

  useEffect(() => {}, []);

  useEffect(() => {
    setStage(props.stage);
  }, [props.stage]);

  const swipeToSlide = (slide) => {
    swiper?.slideTo(slide);
  };

  const slides = props.slides.map((slideData) => (
    <SwiperSlide key={slideData.title}>
      <div className="rings-view__slide-content">
        <p className="rings-view__slide-heading">
          <i className={`icon-trait icon-trait--${slideData.icon}`}></i>
          <span className="rings-view__slide-heading-text  rings-view__gotham">
            {slideData.title}
          </span>
        </p>
        <p className="rings-view__slide-text paragraph">{slideData.text}</p>
      </div>
    </SwiperSlide>
  ));

  const characteristicsTabs = props.slides.map((slideData, index) => {
    const activeTabClass = "rings-view__characteristics-tab--active";
    const isActive = index === activeSlide;

    return (
      <button
        className={`rings-view__characteristics-tab  rings-view__gotham ${
          isActive ? activeTabClass : ""
        }`}
        key={slideData.title}
        onClick={() => swipeToSlide(index)}
      >
        <i className={`icon-trait icon-trait--${slideData.icon}`}></i>
        <span className="rings-view__tab-text">{slideData.title}</span>
      </button>
    );
  });

  const stageTexts = {
    rings: <span className="fade-in">{t("journey.stage_rings")}</span>,
    thickness: <div className="fade-in">{t("journey.stage_thickness")}</div>,
    trunk: <span className="fade-in">{t("journey.stage_trunk")}</span>,
    done: (
      <div className="fade-in headline--primary text-uppercase mb-50">
        {t("journey.catchphrase")}
      </div>
    ),
  };

  const stageText = stageTexts[stage] || "";
  const animationDoneAlert = (
    <span
      className="rings-view__status"
      aria-label={stage === "done" ? t("journey.animation_done_alert") : ""}
      aria-live="polite"
    ></span>
  );

  return (
    <>
      <div className="rings__left">
        {props.isVerticalViz && (
          <RingsViewHeader
            woodcutText={t("journey.woodcut", { username: props.username })}
            date={props.date}
          />
        )}
        <div className="rings__wrapper">{props.children}</div>
        {stage === "done" && (
          <>
            <ShareIcons
              image={props.image}
              modifyingClass="share-view__links-container--small-screen share-view__links-container--visualization-page"
            />
          </>
        )}
      </div>
      <div className="rings__right fade-in">
        <div className="rings-view">
          {!props.isVerticalViz && (
            <RingsViewHeader
              date={props.date}
              woodcutText={t("journey.woodcut", { username: props.username })}
            />
          )}

          <div className="rings-view__catchphrase fade-in" aria-live="polite">
            {stageText}
          </div>

          {props.isVerticalViz && (
            <>
              {stage !== "done" && (
                <div
                  className="rings-view__catchphrase--mobile fade-in"
                  aria-live="polite"
                >
                  {stageText}
                </div>
              )}
            </>
          )}

          {animationDoneAlert}

          {stage === "done" && (
            <div className="fade-in">
              {props.slides.length > 0 && (
                <div className="rings-view__characteristics">
                  <p className="rings-view__characteristics-heading rings-view__gotham">
                    {t("journey.key_characteristics")}
                  </p>
                  <div className="rings-view__tab-container">
                    {characteristicsTabs}
                  </div>
                </div>
              )}
              <div className="rings-view__slider slider fade-in">
                <Swiper
                  modules={[Navigation, Pagination]}
                  spaceBetween={0}
                  slidesPerView={1}
                  navigation={{
                    prevEl: ".rings-view__prev-button",
                    nextEl: ".rings-view__next-button",
                  }}
                  a11y={{
                    prevSlideMessage: t("button.slider_aria_prev"),
                    nextSlideMessage: t("button.slider_aria_next"),
                    paginationBulletMessage: t("button.pagination", {
                      index: "{{index}}",
                    }),
                  }}
                  enabled={props.slides.length > 1}
                  pagination={
                    !props.isLargeScreen &&
                    props.slides.length > 1 && {
                      clickable: true,
                    }
                  }
                  initialSlide={activeSlide}
                  onSlideChange={(swiper) => setActiveSlide(swiper.activeIndex)}
                  onSwiper={setSwiper}
                >
                  {slides}
                  {props.slides.length > 0 && (
                    <>
                      <button className="rings-view__prev-button"></button>
                      <button className="rings-view__next-button"></button>
                    </>
                  )}
                </Swiper>
              </div>

              <TraitsKey />

              <div className="rings-view__button-container">
                <Cta
                  path="/recommendations"
                  ctaClass="cta--primary cta--centered"
                >
                  {t("journey.recomendations_button")}
                </Cta>
                <Cta
                  path="/questionnaire"
                  ctaClass="cta--secondary cta--centered"
                >
                  {t("journey.return_to_questions")}
                </Cta>
              </div>
            </div>
          )}
        </div>
      </div>
      {stage === "done" && (
        <>
          <ShareIcons
            image={props.image}
            modifyingClass="share-view__links-container--visualization-page"
          />
        </>
      )}
    </>
  );
}
